import { connect } from "react-redux";
import { PageRegister } from "senac-components";
import {
  PageRegisteDispach,
  PageRegisterUser,
  PageRegisteStateProps,
} from "senac-components/dist/pages/Mobile/PageRegister";
import { PageRegisterWeb } from "senac-components/dist/pages/Web/PageRegister";
import { AppDispatch, RootState } from "../store";
import { commonSlice, userSlice } from "../store/reducers";
// import { pageRegisterSlice, commonSlice } from "../store/reducers";
// import { RootState, AppDispatch } from "../store";
// import {
//   PageRegisteStateProps,
//   PageRegisteDispach,
//   PageRegisterUser,
// } from "../../.yalc/senac-components/dist/pages/Mobile/PageRegister/index";

const mapState = (state: RootState) => {
  let result: PageRegisteStateProps = {
    loading: state.userState.userRegistering,
    successMessage: false,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageRegisteDispach = {
    onClickBackPage: () => dispatch(commonSlice.actions.backPage()),
    onClickForm: (form: PageRegisterUser) =>
      dispatch(
        userSlice.actions.registerUser({
          name: form.name,
          login: form.login,
          password: form.password,
          cpf: form.cpf,
          email: form.email,
        })
      ),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: () => console.log("onSelectedHeaderMenuOption"),
  };

  return result;
};

const WPageRegister = () => {
  const Mobile = connect(mapState, mapDispatch)(PageRegister);
  const Web = connect(mapState, mapDispatch)(PageRegisterWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageRegister };
